module.exports = __webpack_public_path__ + "img/burger.b6afba23.svg";